// HYUNDAI HD35,45,65,72,78 부품 데이터 (80개)
const createHDProduct = (data: any) => ({
  ...data,
  price: 0,
  status: '재고있음',
  compatibleVehicles: ['HD35', 'HD45', 'HD65', 'HD72', 'HD78'],
  colors: data.colors || ['#808080'],
  features: [
    { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
    { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
    { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
  ],
  craftStory: {
    image: `https://public.readdy.ai/ai/img_res/90d9aafa5f90b4e2cb9ebd506fbc2063.jpg${data.id}craft&orientation=landscape`,
    story: `HD 시리즈의 ${data.description}입니다.`,
    details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
  },
});

export const hdSeriesProducts = [
  createHDProduct({
    id: 'HDS001',
    name: 'HDS001',
    description: 'HEAD LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92101-5H000 L / 92102-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 헤드 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20head%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds001&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS002',
    name: 'HDS002',
    description: 'HEAD LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92101-5K000 L / 92102-5K000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 헤드 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20head%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds002&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS003',
    name: 'HDS003',
    description: 'CORNER LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92301-5H000 L / 92302-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 코너 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20corner%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds003&orientation=portrait',
    images: [],
    colors: ['#FFA500'],
  }),
  createHDProduct({
    id: 'HDS004',
    name: 'HDS004',
    description: 'CORNER LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92301-56001 L / 92302-56001 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 코너 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20corner%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds004&orientation=portrait',
    images: [],
    colors: ['#FFA500'],
  }),
  createHDProduct({
    id: 'HDS005',
    name: 'HDS005',
    description: 'FOG LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92201-5H000 L / 92202-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 포그 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20fog%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds005&orientation=portrait',
    images: [],
    colors: ['#FFFF00'],
  }),
  createHDProduct({
    id: 'HDS006',
    name: 'HDS006',
    description: 'FOG LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92201-56001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 포그 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20fog%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds006&orientation=portrait',
    images: [],
    colors: ['#FFFF00'],
  }),
  createHDProduct({
    id: 'HDS007',
    name: 'HDS007',
    description: 'AUTO LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92303-5H000 L / 92304-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 오토 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20auto%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds007&orientation=portrait',
    images: [],
    colors: ['#FF0000'],
  }),
  createHDProduct({
    id: 'HDS008',
    name: 'HDS008',
    description: 'AUTO LAMP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92401-7A100 L / 92402-7A100 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 오토 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20auto%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds008&orientation=portrait',
    images: [],
    colors: ['#FF0000'],
  }),
  createHDProduct({
    id: 'HDS008LED',
    name: 'HDS008LED',
    description: 'AUTO LAMP LED',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '램프',
    partNumber: '92401-7A100LED L / 92402-7A100LED R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 LED 오토 램프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20LED%20auto%20lamp%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds008led&orientation=portrait',
    images: [],
    colors: ['#FF0000'],
  }),
  createHDProduct({
    id: 'HDS009',
    name: 'HDS009',
    description: 'MIRROR',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '87710-45200',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 미러입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20mirror%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds009&orientation=portrait',
    images: [],
    colors: ['#000000'],
  }),
  createHDProduct({
    id: 'HDS009HT',
    name: 'HDS009HT',
    description: 'MIRROR HEATING',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '87110-5H402',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 히팅 미러입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20heated%20side%20mirror%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds009ht&orientation=portrait',
    images: [],
    colors: ['#000000'],
  }),
  createHDProduct({
    id: 'HDS010',
    name: 'HDS010',
    description: 'GRILLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86310-5H000 / 86320-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 그릴입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20grille%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds010&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS011',
    name: 'HDS011',
    description: 'GRILLE CHROME',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 크롬 그릴입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20chrome%20front%20grille%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds011&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS012',
    name: 'HDS012',
    description: 'GRILLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86310-5L003',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 그릴입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20grille%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds012&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS012W',
    name: 'HDS012W',
    description: 'GRILLE WHITE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 화이트 그릴입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20white%20front%20grille%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds012w&orientation=portrait',
    images: [],
    colors: ['#FFFFFF'],
  }),
  createHDProduct({
    id: 'HDS013',
    name: 'HDS013',
    description: 'GRILLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86310-56000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 그릴입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20grille%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds013&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS014',
    name: 'HDS014',
    description: 'SIDE STEP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86920-5H000 L / 86930-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 사이드 스텝입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20step%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds014&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS015',
    name: 'HDS015',
    description: 'SIDE STEP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86920-5K001 L / 86930-5K001 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 사이드 스텝입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20step%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds015&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS016',
    name: 'HDS016',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86315-5H000 L / 86325-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds016&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS017',
    name: 'HDS017',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82710-56000 L / 82720-56000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds017&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS018',
    name: 'HDS018',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82711-5K000 L / 82710-5K002 L / 82721-5K000 R / 82720-5K002 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds018&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS019',
    name: 'HDS019',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82710-5H002 L / 82720-5H002 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds019&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS020',
    name: 'HDS020',
    description: 'CORNER PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86315-5H001 / 86325-5H001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 코너 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20corner%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds020&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS021',
    name: 'HDS021',
    description: 'CORNER PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86315-5K000 L / 86325-5K000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 코너 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20corner%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds021&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS022',
    name: 'HDS022',
    description: 'FRONT BUMPER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86510-56000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 범퍼입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20bumper%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds022&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS023',
    name: 'HDS023',
    description: 'FRONT BUMPER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86510-56000 / 86510-5K000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 범퍼입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20bumper%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds023&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS033',
    name: 'HDS033',
    description: 'FRONT BUMPER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86510-5H001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 범퍼입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20bumper%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds033&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS043',
    name: 'HDS043',
    description: 'BUMPER SUPPORT',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86515-5K001 L / 86525-5K001 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 범퍼 서포트입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20bumper%20support%20bracket%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds043&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS044',
    name: 'HDS044',
    description: 'BUMPER SUPPORT',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86515-56000 L / 86525-56000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 범퍼 서포트입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20bumper%20support%20bracket%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds044&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS045',
    name: 'HDS045',
    description: 'BUMPER SUPPORT',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86515-5L301 L / 86525-5L301 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 범퍼 서포트입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20bumper%20support%20bracket%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds045&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS024',
    name: 'HDS024',
    description: 'AIR FILTER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '28100-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 에어 필터입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20air%20filter%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds024&orientation=portrait',
    images: [],
    colors: ['#FFFFFF'],
  }),
  createHDProduct({
    id: 'HDS034',
    name: 'HDS034',
    description: 'AIR FILTER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '281005A500',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 에어 필터입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20air%20filter%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds034&orientation=portrait',
    images: [],
    colors: ['#FFFFFF'],
  }),
  createHDProduct({
    id: 'HDS025',
    name: 'HDS025',
    description: 'WATER TANK',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '25361-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 워터 탱크입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20water%20tank%20radiator%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds025&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS026',
    name: 'HDS026',
    description: 'WATER TANK',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '98310-5HA00',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 워터 탱크입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20water%20tank%20radiator%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds026&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS027',
    name: 'HDS027',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '71511-56002',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds027&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS035',
    name: 'HDS035',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '71511-5K001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds035&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS041',
    name: 'HDS041',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '71511-5H202',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds041&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS042',
    name: 'HDS042',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '71511-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds042&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS028',
    name: 'HDS028',
    description: 'MUDGUARD',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '61830/40-5H000/500 / 618315H500',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 머드가드입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20mudguard%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds028&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS029',
    name: 'HDS029',
    description: 'MUDGUARD',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86811-5H101 L / 86821-5H101 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 머드가드입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20mudguard%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds029&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS030',
    name: 'HDS030',
    description: 'HANDLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82310-5H000 L / 82320-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 핸들입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20handle%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds030&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS031',
    name: 'HDS031',
    description: 'HANDLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82330-5H000 L / 82340-5H000 R / 82330-5H003 L / 82340-5H003 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 핸들입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20handle%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds031&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS046',
    name: 'HDS046',
    description: 'GARNISH ASSY',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '81560-5H000 LH / 81570-5H000 RH',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 가니쉬 어셈블리입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20garnish%20assembly%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds046&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS047',
    name: 'HDS047',
    description: 'MIRROR COVER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '87646-5H000 LH / 87656-5H000 RH',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 미러 커버입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20mirror%20cover%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds047&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS048',
    name: 'HDS048',
    description: 'MIRROR COVER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '87646-5L000 LH / 87656-5L000 RH',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 미러 커버입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20mirror%20cover%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds048&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS049',
    name: 'HDS049',
    description: 'SIDE STEP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86910-5K000 / 86920-5K000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 사이드 스텝입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20step%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds049&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS050',
    name: 'HDS050',
    description: 'ENGINE COVER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '65910-5H000 L / 65920-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 엔진 커버입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20engine%20cover%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds050&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS051',
    name: 'HDS051',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '84761-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds051&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS052',
    name: 'HDS052',
    description: 'DOOR PANEL UPPER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '81111-5H011TH L / 81121-5H011TH R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 패널 어퍼입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20panel%20upper%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds052&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS053',
    name: 'HDS053',
    description: 'DOOR PANEL LOWER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '81170-5H000TH L / 81180-5H000TH R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 패널 로어입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20panel%20lower%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds053&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS036',
    name: 'HDS036',
    description: 'SIDE PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '72182-5K001 L / 72192-5K001 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 사이드 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds036&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS037',
    name: 'HDS037',
    description: 'DOOR SILL PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds037&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS038',
    name: 'HDS038',
    description: 'DOOR SILL PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds038&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS039',
    name: 'HDS039',
    description: 'FRONT SHIELD PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 쉴드 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20shield%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds039&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS040',
    name: 'HDS040',
    description: 'FRONT SHIELD PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 쉴드 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20shield%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds040&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS054',
    name: 'HDS054',
    description: 'SIDE STEP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '72182-5H000 L / 72192-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 사이드 스텝입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20side%20step%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds054&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS055',
    name: 'HDS055',
    description: 'DOOR SILL PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '71270-5H005 L / 71280-5K000R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds055&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS056',
    name: 'HDS056',
    description: 'DOOR SILL PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '71235-5K000 L / 71245-5K000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds056&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS032',
    name: 'HDS032',
    description: 'DOOR',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '75003-5H500 L / 75004-5H500 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds032&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS057',
    name: 'HDS057',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86112-5H002',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds057&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS058',
    name: 'HDS058',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82120-5H002 L / 82120-5H000 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds058&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS059',
    name: 'HDS059',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82150-5H003 L / 82160-5H003 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds059&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS060',
    name: 'HDS060',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82145-5H002',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds060&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS061',
    name: 'HDS061',
    description: 'INNER FENDER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '86895-5K001 L / 86896-5K001 R',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 이너 펜더입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20inner%20fender%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds061&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS031C',
    name: 'HDS031C',
    description: 'HANDLE CHROME',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 크롬 핸들입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20chrome%20handle%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds031c&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS037H',
    name: 'HDS037H',
    description: 'DOOR SILL PANEL WITH HOLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 홀이 있는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20with%20hole%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds037h&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS073',
    name: 'HDS073',
    description: 'DOOR SILL PANEL FOOT',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '64170-5H000 / 64180-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널 풋입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20foot%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds073&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS069',
    name: 'HDS069',
    description: 'DOOR SILL PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '72111-5H003 / 72121-5H003',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 실 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20sill%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds069&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS062',
    name: 'HDS062',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82170/80-5H004',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds062&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS063',
    name: 'HDS063',
    description: 'STRIP',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82170/80-5H004',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스트립입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20strip%20trim%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds063&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS064',
    name: 'HDS064',
    description: 'FRONT DOOR WHEEL BRACKET',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '81271-5H000 / 81281-5H000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 프론트 도어 휠 브라켓입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20front%20door%20wheel%20bracket%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds064&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS065',
    name: 'HDS065',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '64510-5K000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds065&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS065F',
    name: 'HDS065F',
    description: 'PANEL FRAME',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '64510-5K000 / 64520-5K000',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널 프레임입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20frame%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds065f&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS065B',
    name: 'HDS065B',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds065b&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS070',
    name: 'HDS070',
    description: 'PANEL',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 패널입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20panel%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot&width=800&height=1000&seq=hds070&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS071',
    name: 'HDS071',
    description: 'ROOF',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 루프입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20roof%20panel%20component%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot%20showing%20metal%20roof%20panel%20structure&width=800&height=1000&seq=hds071&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS067',
    name: 'HDS067',
    description: 'DOOR HANDLE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '82311-5H001 / 82321-5H001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 도어 핸들입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20door%20handle%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot%20showing%20chrome%20door%20handle%20mechanism&width=800&height=1000&seq=hds067&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
  }),
  createHDProduct({
    id: 'HDS066',
    name: 'HDS066',
    description: 'MIRROR EAR',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '외장',
    partNumber: '87629-5H402 / 87639-5H402',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 미러 이어 브라켓입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20mirror%20ear%20bracket%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot%20showing%20mirror%20mounting%20bracket&width=800&height=1000&seq=hds066&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS068',
    name: 'HDS068',
    description: 'SCUFF PLATE',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '내장',
    partNumber: '83180-5H001AQ LH / 83185-5H001AQ RH',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 스커프 플레이트입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20scuff%20plate%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot%20showing%20door%20sill%20scuff%20plate&width=800&height=1000&seq=hds068&orientation=portrait',
    images: [],
  }),
  createHDProduct({
    id: 'HDS072',
    name: 'HDS072',
    description: 'FAN COVER',
    category: 'HYUNDAI HD35,45,65,72,78',
    subcategory: '엔진',
    partNumber: '25397-5H001',
    fullDescription: '현대 HD35, HD45, HD65, HD72, HD78 시리즈에 호환되는 팬 커버입니다.',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20truck%20fan%20cover%20for%20Hyundai%20HD%20series%20professional%20automotive%20part%20photography%20with%20clean%20white%20background%20high%20quality%20industrial%20product%20shot%20showing%20engine%20fan%20cover%20component&width=800&height=1000&seq=hds072&orientation=portrait',
    images: [],
  }),
];
